/**
 * GEHOERT DIESE BUEHNE EINEM PARTNER? — dann steht sie nicht in Rafaels Hof.
 *
 * Rafael, 30.09.2026 (weitergegeben vom Kanzler Dev): *„Lass dir bitte den Berater, seine
 * Bühne, und die haben nur in meiner Ansicht nichts verloren"* und *„Ich will nur, dass
 * die bei meiner Ansicht nicht sichtbar sind. Jeder darf nur das sehen, was ihm gehört.
 * Die Partner sehen ihre."* Raum, Berater und Buehne bleiben unberuehrt — das ist ein
 * Filter der ANSICHT, kein Raumzug. Am selben Tag hatte der Kanzler sie in den
 * Pausenraum geschoben; genau das war falsch.
 *
 * DIE ZUGEHOERIGKEIT STEHT AN DER BUEHNE (`eigentuemer`, Rafael 23.09.2026,
 * e-leck-sauber-20260923 a) — dieselbe Achse, an der die Partner-Sicht (`gehoertMir`,
 * server/routes/shared/meine-buehnen.ts) die Buehne dem Partner oeffnet. Ohne Feld
 * gehoert sie dem Admin und bleibt stehen (fail closed zur Betreiberseite: eher eine
 * Buehne zu viel bei Rafael als eine verschwundene).
 *
 * NUR FUER DEN BETREIBER: ein Partner bekommt vom Server ohnehin nur seine eigenen;
 * auf seiner Seite wird hier nichts weggenommen.
 *
 * GANZ AUSBLENDEN — keine Zeile, kein Zaehler: Rafael, 28.09.2026,
 * e-aufr-partner-buehnen-sicht a. Der Server tat das seit 3b0ee4a41 schon, aber nur fuer
 * einen Abruf, den er als Rafael erkennt; ueber das Partner-Haus kommt Rafaels GET ohne
 * Menschen-Nachweis an und bekam die volle Liste (gemessen 30.09.: 17 statt 13 im
 * Warteraum). Deshalb entscheidet die Flaeche hier selbst noch einmal.
 */

/** Dieselbe Kennung wie `ADMIN_EIGENTUEMER` in server/lib/guide-buehnen.ts. */
export const ADMIN_EIGENTUEMER = 'rafael';

/**
 * ZWEI BELEGE, wie am Server (`partnerBuehne`, lib/guide-buehnen.ts): die Marke
 * `partner_eigen`, die der Server mit beiden Belegen rechnet (Feld UND Partner-Sitzung),
 * und das Feld selbst — falls ein aelterer Server die Marke noch nicht liefert.
 */
export function gehoertEinemPartner(b: { eigentuemer?: unknown; partner_eigen?: unknown }): boolean {
  if (b.partner_eigen === true) return true;
  const e = typeof b.eigentuemer === 'string' ? b.eigentuemer.trim() : '';
  return e !== '' && e !== ADMIN_EIGENTUEMER;
}

export function teileNachEigentum<T extends { eigentuemer?: unknown; partner_eigen?: unknown }>(alle: T[], istBetreiber: boolean): { eigene: T[]; partner: T[] } {
  if (!istBetreiber) return { eigene: alle, partner: [] };
  const eigene: T[] = [];
  const partner: T[] = [];
  for (const b of alle) (gehoertEinemPartner(b) ? partner : eigene).push(b);
  return { eigene, partner };
}
